import * as yup from 'yup';
import { i18n as I18n } from '../utils/i18n';
import { validateXSS, xssErrorMessage } from '../validators';

export const yupServiceSchema = yup.object().shape({
  title: yup.string(),
  serviceType: yup.string().required(
    I18n.t('validations.required', {
      name: I18n.t('registration.service_details.fields.service_type.label'),
    })
  ),
  service: yup
    .string()
    .nullable()
    .required(
      I18n.t('validations.required', {
        name: I18n.t('registration.service_details.fields.service.label'),
      })
    ),
  serviceIdentifier: yup
    .string()
    .test('no-xss', xssErrorMessage, value => validateXSS(value)),
  isCommissionedService: yup.string(),
  serviceCommissioningBody: yup.string().when('isCommissionedService', {
    is: 'Yes',
    then: yup.string().required(
      I18n.t('validations.required', {
        name: I18n.t(
          'registration.service_details.fields.service_commissioning_body.label'
        ),
      })
    ),
  }),
  isLicensedForService: yup.string(),
  serviceLicensingBody: yup.string().when('serviceType', {
    is: 'Clinical',
    then: yup
      .string()
      .trim()
      .test('no-xss', xssErrorMessage, value => validateXSS(value))
      .required(
        I18n.t('validations.required', {
          name: I18n.t(
            'registration.service_details.fields.service_governing_body.label'
          ),
        })
      ),
  }),
  serviceRegistrationNo: yup.string().when('serviceType', {
    is: 'Clinical',
    then: yup
      .string()
      .trim()
      .test('no-xss', xssErrorMessage, value => validateXSS(value))
      .required(
        I18n.t('validations.required', {
          name: I18n.t(
            'registration.service_details.fields.service_registration_no.label'
          ),
        })
      ),
  }),
});
